import type { ValueType, ValidatorOptions } from './is-more-number-validator.types';
import { errorMessages } from '../../error-messages';

const DEFAULT_OPTIONS: Required<ValidatorOptions> = {
  comparisonValueRequired: true,
  variant: 'more',
  message: errorMessages.numberError,
};

export const isMoreNumberValidator = (
  required = true,
  comparisonValue: ValueType,
  options: ValidatorOptions = {},
) => {
  const {
    comparisonValueRequired = DEFAULT_OPTIONS.comparisonValueRequired,
    variant = DEFAULT_OPTIONS.variant,
    message = DEFAULT_OPTIONS.message,
  } = options;

  return (_: any, value: ValueType) => {
    if (!value) {
      return required ? Promise.reject(errorMessages.required) : Promise.resolve();
    }

    if (!comparisonValue) {
      return comparisonValueRequired ? Promise.reject(message) : Promise.resolve();
    }

    switch (variant) {
      case 'more': {
        if (value > comparisonValue) {
          return Promise.resolve();
        } else {
          return Promise.reject(message);
        }
      }
      case 'same or more': {
        if (value >= comparisonValue) {
          return Promise.resolve();
        } else {
          return Promise.reject(message);
        }
      }
      default: {
        return Promise.reject(message);
      }
    }
  };
};
